// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__Nei__","field-name":"style_field-name__HCTJ5","value":"style_value__y8PWi"};